import {otsBaseApi} from "../../ots-api";
import {ABACPolicy} from "../../../model/abac-policy";

const taggedBaseApi = otsBaseApi.enhanceEndpoints({addTagTypes: ["ABACPolicies", "PermissionABACPolicies"]});

const abacPolicyApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllABACPolicies: builder.query<
      ABACPolicy[],
      void
    >({
      query: () => ({
        url: `/abac-policies/all`,
        method: 'GET',
      }),
      providesTags: (result) => {
        if (result) {
          return [
            ...result.map(({id}) => ({type: "ABACPolicies", id} as const)),
            {type: "ABACPolicies", id: "LIST"}
          ];
        } else {
          return [{type: "ABACPolicies", id: "LIST"}];
        }
      },
    }),
    getABACPoliciesByPermission: builder.query<
      ABACPolicy[],
      string
    >({
      query: (arg) => ({
        url: `/abac-policies/all`,
        method: 'GET',
        params: {
          permissionId: arg
        }
      }),
      providesTags: (result, _error, arg) => {
        if (result) {
          return [
            ...result.map(({id}) => ({type: "ABACPolicies", id} as const)),
            {type: "PermissionABACPolicies", id: arg}
          ];
        } else {
          return [{type: "PermissionABACPolicies", id: arg}];
        }
      },
    }),
    getABACPolicy: builder.query<ABACPolicy, string>({
      query: (id) => ({
        url: `/abac-policies/${id}`,
        method: "GET",
      }),
      providesTags: (result, error, id) => [{type: "ABACPolicies", id}]
    }),
    createABACPolicy: builder.mutation<ABACPolicy, Partial<ABACPolicy>>({
      query: (mapping) => ({
        url: "/abac-policies",
        method: "POST",
        body: mapping
      }),
      invalidatesTags: [{type: "ABACPolicies", id: "LIST"}]
    }),
    updateABACPolicy: builder.mutation<ABACPolicy, Partial<ABACPolicy>>({
      query: (mapping) => ({
        url: "/abac-policies",
        method: "PUT",
        body: mapping,
      }),
      invalidatesTags: (result, error, {id}) => [
        {type: "ABACPolicies", id},
      ]
    }),
    deleteABACPolicy: builder.mutation<void, Partial<ABACPolicy>>({
      query: (mapping) => ({
        url: "/abac-policies",
        method: "DELETE",
        body: mapping
      }),
      invalidatesTags: (result, error, {id}) => [{type: "ABACPolicies", id}]
    })
  })
});

export const {
  useGetAllABACPoliciesQuery,
  useGetABACPoliciesByPermissionQuery,
  useGetABACPolicyQuery,
  useCreateABACPolicyMutation,
  useUpdateABACPolicyMutation,
  useDeleteABACPolicyMutation,
} = abacPolicyApi;
